import { forwardRef, Component } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { DateRangePickerComponent } from './date-range-picker.component';

@Component({
  selector   : 'nz-week-picker',
  template: `<nz-picker [isRange]="isRange" [value]="nzValue" (valueChange)="onValueChange($event)" [open]="nzOpen" [disabled]="nzDisabled" [format]="nzFormat" [allowClear]="nzAllowClear" [autoFocus]="nzAutoFocus" [className]="nzClassName" [placeholder]="nzPlaceHolder" [size]="nzSize" [style]="nzStyle" (openChange)="onOpenChange($event)" > <date-range-popup *ngIf="realOpenState" [isRange]="isRange" [showWeek]="showWeek" [panelMode]="nzMode" (panelModeChange)="nzOnPanelChange.emit($event)" [value]="nzValue" (valueChange)="onValueChange($event)" [locale]="nzLocale?.lang" [showToday]="realShowToday" [showTime]="nzShowTime" [format]="nzFormat" [dateRender]="nzDateRender" [disabledDate]="nzDisabledDate" [disabledTime]="nzDisabledTime" [placeholder]="nzPlaceHolder" [dropdownClassName]="nzDropdownClassName" [popupStyle]="nzPopupStyle" [extraFooter]="extraFooter" [ranges]="nzRanges" (resultOk)="onResultOk()" (closePicker)="closeOverlay()" ></date-range-popup> </nz-picker>`,
  providers  : [ {
    provide    : NG_VALUE_ACCESSOR,
    multi      : true,
    useExisting: forwardRef(() => NzWeekPickerComponent)
  } ],
  host       : {
    '[class.ant-calendar-picker]': 'true'
  }
})

export class NzWeekPickerComponent extends DateRangePickerComponent {
  showWeek: boolean = true;
}
